import { atom } from 'jotai';
import { SplitOrderInvoicesDetailModel, SplitOrderInvoicesDetailPageState } from './split_order_invoices_detail_types';
import {
    splitOrderInvoicesDetailModelVM,
    splitOrderInvoicesDetailPageStateVM,
} from './split_order_invoices_detail_view_models';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import {
    SplitOrderInvoicesDetailLineItem,
    InvoiceLineItemDispensesDataItem,
} from './split_order_invoices_detail_types';

// PAGE STATE
export const splitOrderInvoicesDetailPageStateAtom = atom<SplitOrderInvoicesDetailPageState>(
    splitOrderInvoicesDetailPageStateVM(),
);
export const splitOrderInvoicesDetailModelAtom = atom<SplitOrderInvoicesDetailModel>(splitOrderInvoicesDetailModelVM());

// LINE ITEMS TABLE
export const splitOrderInvoicesDetailTableStateAtom = atom<TableState>(tableStateVM());
export const splitOrderInvoicesDetailTableViewAtom = atom<TblView>(tableViewVM());
export const splitOrderInvoicesDetailTableStatsAtom = atom<TblStats>(tableStatsVM());
export const splitOrderInvoicesDetailTableFiltersAtom = atom<TableFilters>({});
export const splitOrderInvoicesDetailLineItemsAtom = atom<TableDataState<SplitOrderInvoicesDetailLineItem>>({
    items: [],
    dataItems: [],
});

// BACKING DISPENSES TABLE
export const splitInvoiceLineItemDispensesTableStateAtom = atom<TableState>(tableStateVM());
export const splitInvoiceLineItemDispensesTableViewAtom = atom<TblView>(tableViewVM());
export const splitInvoiceLineItemDispensesTableStatsAtom = atom<TblStats>(tableStatsVM());
export const splitInvoiceLineItemDispensesTableFiltersAtom = atom<TableFilters>({});
export const splitInvoiceLineItemDispensesDataAtom = atom<TableDataState<InvoiceLineItemDispensesDataItem>>({
    items: [],
    dataItems: [],
});
